import { makeRequest } from '../../../../lib/api';
import { FindPartnerRequest } from '../../api/partnerAPI';

const SERVICE_OFFICE_PATH = '/v1/service_office';

const B2B_CUSTOMER_PATH = '/v1/partner/b2b_customers';

const partnerOrderController = {
  getServiceOfficeSTO: (serviceId: number, showDeleted = false): Promise<any> => {
    const paramDeleted = showDeleted ? 'showDeleted=true' : 'showDeleted=false';
    return makeRequest('get', `${ SERVICE_OFFICE_PATH }/offices?serviceId=${ serviceId }&${ paramDeleted }`);
  },

  getB2BCustomers: (): Promise<any> => {
    return makeRequest('get', `${ B2B_CUSTOMER_PATH }`);
  },

  findPartner: (data:FindPartnerRequest): Promise<any> => {
    return makeRequest('post', `${ B2B_CUSTOMER_PATH }/${ data.orderId }/find/partner`);
  },

};

export { partnerOrderController };
